"use client";

import { useEffect, useRef, useState } from "react";
import S from "./index.module.scss";
import { Container } from "@/components/ui/container";

const BrandStory = () => {
  const [isVisible, setIsVisible] = useState(false);
  const introRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const intro = introRef.current;

    if (!intro) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(intro);

    return () => observer.disconnect();
  }, []);

  return (
    <section className={S.brandStory} data-visible={isVisible}>
      <Container className={S.container}>
        <div ref={introRef} className={S.storyIntro}>
          <p className={S.label}>История бренда</p>
          <h2 className={S.heading}>
            <span>Где время</span>
            <span>встречается</span>
            <span>с архитектурой</span>
          </h2>
          <p className={S.description}>
            Каждые часы - это воплощение архитектурных принципов, переосмысленных в часовом искусстве. Северная
            сдержанность встречается с геометрией ар-деко, создавая инструменты времени, выходящие за рамки трендов.
          </p>
        </div>

        <div className={S.sketchWrapper}>
          <img src="/images/home/story/item-4.png" alt="Архитектурный эскиз корпуса часов" className={S.sketch} />
          <p className={S.caption}>
            <span>Создано в Санкт-Петербурге.</span>
            <span>Выполнено с абсолютной точностью.</span>
          </p>
        </div>

        <div className={S.precision}>
          <div className={S.precisionLeft}>
            <img src="/images/home/story/item-1.jpg" alt="Деталь механизма часов" />
          </div>
          <div className={S.precisionRight}>
            <img src="/images/home/story/item-2.jpg" alt="Ручная обработка детали часов" />
          </div>
          <div className={S.precisionWords}>
            <span>точность</span>
            <span>в каждой</span>
            <span>детали</span>
          </div>
        </div>

        <div className={S.movement}>
          <img src="/images/home/story/item-3.png" alt="Открытый механизм часов" className={S.movementImage} />
          <p className={S.movementText}>
            Каждый компонент создаётся с предельной точностью. От выверенных граней корпуса до архитектурного циферблата
            - мастер прорабатывает каждую деталь, добиваясь идеального баланса формы и функции.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default BrandStory;
